export default "__VITE_ASSET__Q_M9rJsF__"